import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Routable::ErrorUnauthorizedRoute @model={{@model}} />",{ moduleName: "mewe/templates/error-401.hbs" })